import Vue from 'vue';

export default (filter, cb) => {
  Vue.$http
    .get('customers', { params: filter })
    .then((response) => {
      cb(null, response);
    })
    .catch((error) => {
      cb(error);
    });
};



// WEBPACK FOOTER //
// ./src/services/customer/get.js